import { render, staticRenderFns } from "./ExcelExpedientes.vue?vue&type=template&id=1e0664d8&"
import script from "./ExcelExpedientes.vue?vue&type=script&lang=js&"
export * from "./ExcelExpedientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports